import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
export interface Jornada {
  id: number;
  nomeJornada: string;
}

@Injectable({
  providedIn: 'root'
})
export class JornadaService {

  //private apiUrl = 'https://localhost:7103/api/JornadaTrabalho';   

  //getJornadas(): Observable<Jornada[]> {
    //return this.http.get<Jornada[]>(this.apiUrl);
  //}
  
  constructor(private http: HttpClient) { }


  private baseUrl = environment.apiUrlExbeOn;
  private endpoint = '/JornadaTrabalho';
  

  getJornadas(): Observable<Jornada[]> {
    return this.http.get<Jornada[]>(`${this.baseUrl}${this.endpoint}`);
  }
  
}
